import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tw_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const SERVICES = [
  {
    key: "boxing",
    name: "Boxing Arena",
    tagline: "Book matches & buy tickets",
    description: "Live championship boxing matches, ringside seating, and event tickets.",
    image: "https://customer-assets.emergentagent.com/job_twinstars-demo/artifacts/45anpc80_IMG_7213.jpeg",
    accent: "#FF3333",
  },
  {
    key: "spa",
    name: "Spa & Wellness",
    tagline: "Massage. Facial. Therapy.",
    description: "Restorative spa treatments by certified therapists.",
    image: "https://images.pexels.com/photos/18120171/pexels-photo-18120171.jpeg",
    accent: "#0A0A0A",
  },
  {
    key: "gym",
    name: "Gym & Fitness",
    tagline: "Train with elite coaches",
    description: "State-of-the-art equipment, group classes & personal training.",
    image: "https://images.pexels.com/photos/35529263/pexels-photo-35529263.jpeg",
    accent: "#0022FF",
  },
  {
    key: "guesthouse",
    name: "Guesthouse",
    tagline: "Hotel-class rooms & apartments",
    description: "Book serviced apartments with concierge & housekeeping.",
    image: "https://images.pexels.com/photos/6394651/pexels-photo-6394651.jpeg",
    accent: "#0A0A0A",
  },
  {
    key: "barber",
    name: "Barbing Salon",
    tagline: "Sharp cuts, on demand",
    description: "Master barbers, beard sculpting & grooming appointments.",
    image: "https://images.pexels.com/photos/9992820/pexels-photo-9992820.jpeg",
    accent: "#0A0A0A",
  },
  {
    key: "washingbay",
    name: "Washing Bay",
    tagline: "Car wash & detailing",
    description: "Premium detailing, foam wash, interior valet & queue tracking.",
    image: "https://images.pexels.com/photos/28995189/pexels-photo-28995189.jpeg",
    accent: "#0022FF",
  },
  {
    key: "laundry",
    name: "Laundry",
    tagline: "Pickup Tue · Delivery Sat",
    description: "Weekly pickup & delivery, professional laundry & dry cleaning.",
    image: "https://images.pexels.com/photos/8774651/pexels-photo-8774651.jpeg",
    accent: "#FF3333",
  },
];

export const JOB_ROLES = [
  { key: "spa_therapist", name: "Spa Therapist", section: "Spa" },
  { key: "gym_trainer", name: "Gym Trainer", section: "Gym" },
  { key: "barber", name: "Barber", section: "Barbing" },
  { key: "car_wash_staff", name: "Car Wash Staff", section: "Washing Bay" },
  { key: "laundry_staff", name: "Laundry Staff", section: "Laundry" },
  { key: "guesthouse_receptionist", name: "Guesthouse Receptionist", section: "Guesthouse" },
  { key: "cleaner", name: "Cleaner", section: "Facilities" },
  { key: "security", name: "Security", section: "Facilities" },
  { key: "sales_rep", name: "Sales Representative", section: "Boutique" },
  { key: "supervisor", name: "Supervisor", section: "Operations" },
  { key: "personal_assistant", name: "Personal Assistant", section: "Operations" },
];

export const HERO_IMAGE = "https://static.prod-images.emergentagent.com/jobs/5d78b116-4de2-4cf5-beab-5eef413728eb/images/87384e50e43eceb9d2603c82c8dc0536a5020524e74c1391d73a92597bc860a5.png";
export const LOGO_MARK = "https://static.prod-images.emergentagent.com/jobs/5d78b116-4de2-4cf5-beab-5eef413728eb/images/f1df757bfac5d9f35a70978fa0ab8d3eb0c689b06a3d9ff8a3b7d2b15b1c9db6.png";
